export default __webpack_public_path__ + "static/media/icaw.414c560d.svg";